import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showSuccess, showError } from "../../utils/snackbarHelpers";
import { config } from '../../config';

const AcceptInvitationRequest = () => {
    const { boardId, shortId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [accepting, setAccepting] = useState(false);

    // Extract token from query parameters
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    const invitationType = boardId ? 'board' : 'workspace';
    const id = boardId || shortId; // Either boardId or workspace shortId

    useEffect(() => {
        if (!token) {
            showError(dispatch, 'Invalid link: Missing token');
            navigate('/');
            return;
        }

        const acceptInvitation = async () => {
            setAccepting(true);
            try {
                const endpoint =
                    invitationType === 'board'
                        ? `${config.API_URI}/v1/boards/accept`
                        : `${config.API_URI}/v1/workspace/accept`;

                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({ id, token }),
                });

                const data = await response.json();


                if (response.ok) {
                    // Save the access token if provided (for backward compatibility)
                    if (data.accessToken) {
                        localStorage.setItem('accessToken', data.accessToken);
                    }

                    // Determine success message based on user status
                    let successMessage = `Successfully joined the ${invitationType}`;
                    if (data.userActivated) {
                        successMessage = `Welcome! Your account has been activated and you've joined the ${invitationType}`;
                    } else if (data.userVerified) {
                        successMessage = `Your account has been verified and you've joined the ${invitationType}`;
                    }

                    showSuccess(dispatch, successMessage);

                    setTimeout(() => {
                        if (!data.isDefaultPasswordSet) {
                            // Redirect to set password page
                            window.location.href = '/set-password';
                        } else {
                            // Redirect to the board or workspace
                            const redirectPath =
                                invitationType === 'board' ? `/b/${id}` : `/w/${id}/boards`;
                            window.location.href = redirectPath;
                        }
                    }, 1500); // Slightly longer to read the message
                } else {
                    showError(dispatch, data.message || `Failed to join ${invitationType}`);
                }
            } catch (error) {
                showError(dispatch, `Error accepting ${invitationType}`);
            } finally {
                setAccepting(false);
            }
        };

        acceptInvitation();
    }, [token, id, invitationType, dispatch, navigate]);

    if (accepting) {
        return <div>Joining {invitationType}...</div>;
    }

    return null;
};

export default AcceptInvitationRequest;
